module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"like":"Подобається","unlike":"Не подобається"},"en":{"like":"Like","unlike":"Don\u0027t like"}}')
  delete Component.options._Ctor
}
